import {useMemo} from 'react';
import {
  IntentSignalDisplayField,
  IntentGroup,
  useIntentModelStore,
} from './IntentModeStore';
import {entries} from '../../shared/util';

export function useIntentGroups() {
  const {displayFields} = useIntentModelStore();

  return useMemo(() => {
    const groups = displayFields.reduce(
      (acc, field) => {
        if (!acc[field.group]) {
          acc[field.group] = [];
        }
        acc[field.group].push(field);

        return acc;
      },
      {} as Record<IntentGroup, IntentSignalDisplayField[]>
    );

    return entries(groups).map(([group, fields]) => {
      return {
        group,
        fields,
      };
    });
  }, [displayFields]);
}
